import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let skip_flag_initial_values = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'data.skip_flags',
  })
  return useMemo(() => {
    if (skip_flag_initial_values && skip_flag_initial_values !== null) {
      let flags = data.map(flag => {
        let value = skip_flag_initial_values.find(
          initial_flag => initial_flag.flag === flag.flag
        )?.value
        if (value) {
          return { ...flag, value }
        }
        return flag
      })
      return flags
    }
    return data
  }, [data, skip_flag_initial_values])
}
